export default "__VITE_ASSET__BnGBiZ1J__"